import { restClient } from '@/Core'

interface MarkReadResponse {
    unreadCount?: number
}

/** Marks all chat messages as read for the current user, returns the new unreadCount (always 0) */
export const MarkChatReadTask = async (chatId: string): Promise<number> => {
    const response = (await restClient.patch(`/services/chat/chats/${chatId}/read`)) as MarkReadResponse | null

    return response?.unreadCount ?? 0
}
